import generate from './tools/generate'

function tryout() {
    return {
        state: null,
        history_hash: null,
        questions: null,
        activeQuestionIdx: null,
        answers: null,
        remaining_second: null,
        title: null,
        questionNavigator: null,
        autoScroll: true,
        finishDialog: false,
        fontSize: 1,
        questionRandomized: null,
    }
}

const getters = {
    activeQuestion(state) {
        return state.questions[state.activeQuestionIdx]
    },

    activeAnswer(state) {
        return state.answers[state.activeQuestionIdx]
    },

    fontSizeInlineStyle(state) {
        return {
            'font-size': `${state.fontSize}rem !important`,
            'line-height': `${state.fontSize + 0.5}rem !important`
        }
    },
}

const mutations = {
    ...generate.mutations(tryout()),

    RUN_TIMER(state) {
        state.remaining_second--
        state.answers[state.activeQuestionIdx].active_time++
    }
}

const actions = {
    increaseFont({ state, commit }) {
        commit('SET_FONT_SIZE', state.fontSize + 0.1)
    },

    decreaseFont({ state, commit }) {
        if (state.fontSize > 0.5) {
            commit('SET_FONT_SIZE', state.fontSize - 0.1)
        }
    },

    prevQuestion({ state, commit }) {
        commit('SET_ACTIVE_QUESTION_IDX', state.activeQuestionIdx - 1)
    },

    nextQuestion({ state, commit }) {
        commit('SET_ACTIVE_QUESTION_IDX', state.activeQuestionIdx + 1)
    },
}

export default {
    namespaced: true,
    state: tryout(),
    getters,
    mutations,
    actions,
}
